import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { environment } from '@environment/environment';

interface ImpClaim {
  by_user_id: string;
  by_email: string;
  session_id: string;
  started_at: number;
}

interface RecruiterTokenPayload {
  exp: number;
  recruiter_id?: string;
  imp?: ImpClaim;
}

@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  isImpersonating = false;
  impersonationData: { impersonator_email: string; started_at: number } | null = null;
  expiresAt = 0;

  constructor(private http: HttpClient, private envService: CommonEnvironmentsService) {}

  init(): void {
    const token = this.envService.getToken();
    if (!token) return;
    let p: RecruiterTokenPayload;
    try { p = jwtDecode<RecruiterTokenPayload>(token); } catch { return; }
    if (!p?.imp) return;
    this.isImpersonating = true;
    this.impersonationData = { impersonator_email: p.imp.by_email, started_at: p.imp.started_at };
    this.expiresAt = p.exp;
  }

  // Indirection so specs can spy on navigation; window.location itself is not
  // mockable in modern browsers.
  redirect(url: string): void {
    window.location.assign(url);
  }

  async exit(): Promise<void> {
    const token = this.envService.getToken();
    let recruiterId = '';
    if (token) {
      try { recruiterId = jwtDecode<RecruiterTokenPayload>(token).recruiter_id || ''; } catch { /* ignore */ }
    }
    try {
      await this.http
        .post(`${environment.ENDPOINTS.BACK_END.V3}/admin/exit-impersonation`, {})
        .toPromise();
    } catch { /* best-effort */ }
    this.envService.cleanStorage();
    this.redirect(`${environment.ENDPOINTS.FRONT_END.ADMIN}/recruiters/${recruiterId}`);
  }
}
